import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface AirflowConnector {
  baseUrl: string;
  userId: string;
  password: string;
  apimId: string;
  accessToken:string;
}


@Injectable({
  providedIn: 'root'
})
export class ConnectorsService {
  private apiServiceUrl = environment.apiUrl;
  deleteConnectorModal = new BehaviorSubject<any>(null);
  editConnectorModal = new BehaviorSubject<any>(null);
  deleteConnector = new BehaviorSubject<any>(null);
  constructor(private http: HttpClient) { }
  public getAllConnectorList(): Observable<any> {
    const url = `${this.apiServiceUrl}/ava/aipo/report/itsm-credentials`;
    return this.http.get(url).pipe(
      map((response: any) => {
        return response;
      })
    );
  }

  public submitJiraConnectorCredentials(credentialsJiraData: any): Observable<any> {
    const url = `${this.apiServiceUrl}/aipo/platform/api/jira/connector/credential/save`;
    return this.http.post(url, credentialsJiraData).pipe(
      map((response: any) => {
        return response
      })
    )
  }
  public submitServiceDeskConnectorCredentials(credentialsServiceDeskData: any): Observable<any> {
    const url = `${this.apiServiceUrl}/aipo/platform/api/servicedesk/connector/credential/save`;
    return this.http.post(url, credentialsServiceDeskData).pipe(
      map((response: any) => {
        return response
      })
    )
  }
  public submitServiceNowConnectorCredentials(credentialsServiceNowData: any): Observable<any> {
    const url = `${this.apiServiceUrl}/ava/aipo/platform/api/snow/connector/credential/save`;
    return this.http.post(url, credentialsServiceNowData).pipe(
      map((response: any) => {
        return response
      })
    )
  }
  public getPerticularJiraConnector(itsmName: any, projectName: any,): Observable<any> {
    const url = `${this.apiServiceUrl}/aipo/platform/api/jira/connector/credential/view?projectName=${projectName}&itsmName=${itsmName}`;
    return this.http.get(url).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
  public getPerticularServiceDeskConnector(itsmName: any, projectName: any,): Observable<any> {
    const url = `${this.apiServiceUrl}/aipo/platform/api/servicedesk/connector/credential/view?&itsmName=${itsmName}&?projectName=${projectName}`;
    return this.http.get(url).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
  public getPerticularServiceNowConnector(itsmName: any): Observable<any> {
    const url = `${this.apiServiceUrl}/ava/aipo/platform/api/snow/connector/credential/view?itsmName=${itsmName}`;
    return this.http.get(url).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
  public editJiraConnector(itsmName: any, projectName: any, credentialsData: any): Observable<any> {
    const url = `${this.apiServiceUrl}/aipo/platform/api/jira/connector/credential/edit?itsmName=${itsmName}&projectName=${projectName}`;
    return this.http.put(url, credentialsData).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
  public editServiceDeskConnector(itsmName: any, projectName: any, credentialsData: any): Observable<any> {
    const url = `${this.apiServiceUrl}/aipo/platform/api/servicedesk/connector/credential/edit?itsmName=${itsmName}&projectName=${projectName}`;
    return this.http.put(url, credentialsData).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
  public editServiceNowConnector(itsmName: any, callerName: any, credentialsData: any): Observable<any> {
    const url = `${this.apiServiceUrl}/ava/aipo/platform/api/snow/connector/credential/edit?itsmName=${itsmName}&callerName=${callerName}`;
    return this.http.put(url, credentialsData).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
  deleteJiraConnector(itsmName: any, projectName: any): Observable<any> {
    const url = `${this.apiServiceUrl}/aipo/platform/api/jira/connector/credential/delete?itsmName=${itsmName}&projectName=${projectName}`;
    return this.http.delete(url).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
  deleteServiceDeskConnector(itsmName: any, projectName: any): Observable<any> {
    const url = `${this.apiServiceUrl}/aipo/platform/api/servicedesk/connector/credential/delete?itsmName=${itsmName}&projectName=${projectName}`;
    return this.http.delete(url).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
  deleteServiceNowConnector(itsmName: any): Observable<any> {
    const url = `${this.apiServiceUrl}/ava/aipo/platform/api/snow/connector/credential/delete?itsmName=${itsmName}`;
    return this.http.delete(url).pipe(
      map((response: any) => {
        return response;
      })
    );
  }

  public getJiraTimeZone() {
    const url = `${this.apiServiceUrl}/aipo/platform/api/jira/connector/get-timezone`;
    return this.http.get(url)
  }

  public getServiceNowTimeZome() {
    const url = `${this.apiServiceUrl}/ava/aipo/platform/api/snow/connector/get-timezone`;
    return this.http.get(url);
  }

  public processList() {
    const url = `${this.apiServiceUrl}/aipo/platform/api/airflow/connector/credentials/available-processes`;
    return this.http.get(url);
  }

  public getMonitorServicesList() {
    const url = `${this.apiServiceUrl}/aipo/platform/api/airflow/connector/credentials`;
    return this.http.get(url);
  }

  public saveAirflowConnector(payload: any) {
    const url = `${this.apiServiceUrl}/aipo/platform/api/airflow/connector/credentials`;
    return this.http.post(url, payload)
  }

  public deleteMonitorConnector(requestId: any) {
    const url = `${this.apiServiceUrl}/aipo/platform/api/airflow/connector/credentials/delete?requestId=${requestId}`;
    return this.http.delete(url)
  }

  getAirflowConnectorByRequestId(requestId: string): Observable<any> {
    const url = `${this.apiServiceUrl}/aipo/platform/api/airflow/connector/credentials/view?requestId=${requestId}`;
    return this.http.get<any>(url);
  }

  updateAirflowConnector(requestId: string , payload: any) {
    const url = `${this.apiServiceUrl}/aipo/platform/api/airflow/connector/credentials/update?requestId=${requestId}`;
    return this.http.put(url, payload);
  }

}
